import { render, staticRenderFns } from "./BackToTopModule.vue?vue&type=template&id=30ec9964&"
import script from "./BackToTopModule.ts?vue&type=script&lang=ts&"
export * from "./BackToTopModule.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports